"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCells = void 0;
exports.generateHeaderRows = generateHeaderRows;
var _CurrencyFormatter = _interopRequireDefault(require("../../../common/Formatters/CurrencyFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// [
//   {
//     name: 'functionName',
//     value: 'numberOfEmployees',
//     headers: [
//       111, //average,
//       222, //ownValue,
//       333, //delta
//     ],
//   },
// ];

function generateHeaderRows(translate, headerRowGenerator) {
  if (headerRowGenerator) {
    return headerRowGenerator();
  }
  let headerLabelKeys = ['function', 'numberOfEmployee', 'baseSalary', 'additional', 'variable', 'grossSalary'];
  let headerRows = [];
  let firstHeaderRow = {
    className: 'grey-border',
    headers: headerLabelKeys.map((key, index) => {
      let baseObject = {
        id: key,
        key: key,
        colSpan: 3,
        name: translate(`benchmarking.data-table.header-row.${key}`),
        className: 'bold-header no-border'
      };
      if (index === 0) {
        return {
          ...baseObject,
          colSpan: 1,
          rowSpan: 2,
          className: 'no-border left-align'
        };
      }
      if (index === 1) {
        return {
          ...baseObject,
          colSpan: 1,
          rowSpan: 2,
          className: 'no-border number-of-employees'
        };
      }
      return baseObject;
    })
  };
  headerRows.push(firstHeaderRow);
  let subheaderLabelKeys = ['baseSalary', 'additional', 'variable', 'grossSalary'];
  let secondHeaderRow = {
    className: 'grey-border',
    headers: []
  };
  subheaderLabelKeys.forEach((key, index) => {
    secondHeaderRow.headers.push({
      headers: key,
      key: `average${key}`,
      name: translate('benchmarking.data-table.header-row.average'),
      className: 'no-right-padding'
    }, {
      headers: key,
      key: `ownValue${key}`,
      name: translate('benchmarking.data-table.header-row.ownValue'),
      className: 'middle-col'
    }, {
      headers: key,
      key: `delta${key}`,
      name: translate('benchmarking.data-table.header-row.delta'),
      className: 'no-left-padding'
    });
  });
  headerRows.push(secondHeaderRow);
  return headerRows;
}
const generateCells = (items, colNumber, formattedCurrency) => {
  let cells = items.map(item => {
    let cols = [];
    let firstTwoCols = [{
      value: item.name,
      className: 'left-align',
      key: 0
    }, {
      value: item.value,
      className: 'center-align',
      key: 1
    }];
    cols.push(...firstTwoCols);
    for (let index = 0; index < colNumber; index++) {
      let groupedCols = [{
        value: formattedCurrency ? _CurrencyFormatter.default.format(item.headers[index][0], false, true) : item.headers[index][0],
        className: 'average',
        key: `${index}_average`
      }, {
        value: formattedCurrency ? _CurrencyFormatter.default.format(item.headers[index][1], false, true) : item.headers[index][1],
        className: 'own-value',
        key: `${index}_own`
      }, {
        value: formattedCurrency ? _CurrencyFormatter.default.format(item.headers[index][2], false, true) : item.headers[index][2],
        className: 'delta',
        key: `${index}_delta`
      }];
      cols.push(...groupedCols);
    }
    return cols;
  });
  return cells;
};
exports.generateCells = generateCells;